const LOCALES = {
  "en-US": "US",
  "en-CA": "CA",
  "fr-CA": "FC",
  "en-GB": "UK",
  "de-DE": "DE",
  "fr-FR": "FR",
  "nl-BE": "NB",
  "fr-BE": "FB",
  "sv-SE": "SE",
  "en-AU": "AU"
};

export function getMarketByLocale(market) {
  if (!LOCALES[market]) {
    throw new Error(
      "Invalid locale given, please check value and capitalization."
    );
  }

  return LOCALES[market];
}
